/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, type ErrorResponse, type InternalErrorResponse } from '../../../../../models/index.js';
// @ts-ignore
import { ImageRequestBuilderRequestsMetadata, type ImageRequestBuilder } from './image/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/flipbooks/{flipbookId}/pages/{pageNumber}
 */
export interface WithPageNumberItemRequestBuilder extends BaseRequestBuilder<WithPageNumberItemRequestBuilder> {
    /**
     * The image property
     */
    get image(): ImageRequestBuilder;
    /**
     * Remove one page and its product tags from a flipbook. The pages after it move up one number and keep their tags. The page's image is removed.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 404 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     delete(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<void>;
    /**
     * Remove one page and its product tags from a flipbook. The pages after it move up one number and keep their tags. The page's image is removed.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toDeleteRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const WithPageNumberItemRequestBuilderUriTemplate = "{+baseurl}/api/flipbooks/{flipbookId}/pages/{pageNumber}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const WithPageNumberItemRequestBuilderNavigationMetadata: Record<Exclude<keyof WithPageNumberItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    image: {
        requestsMetadata: ImageRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const WithPageNumberItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    delete: {
        uriTemplate: WithPageNumberItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/problem+json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
    },
};
/* tslint:enable */
/* eslint-enable */
